import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system"
import { Link } from "react-router-dom";

const CircularContainer = styled(Box)(({ theme }) => ({
    width: '4em',
    height: '4em',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // background: '#F95799',
    border: '1px solid #F95799',
    borderRadius:'50%',
    margin: '5px',
    marginRight: '10px',
    
}))

const Circle = (props) => {
    const highlightBorder = props.highlight ? { background: '#f0f0f0', width: '4em', height: '4em', borderRadius: '50%' ,border: "2px solid #db2c2c"} :{ background: '#f0f0f0', width: '4em', height: '4em', borderRadius: '50%' }
    return (
        <>
            <Box component={Link} to={`${props.categoryUrl}`} sx={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', gap: '5px',marginRight:'10px', alignItems: 'center' }}>
                {/* <CircularContainer> */}

                    <img src={props?.content} style={highlightBorder} />
                {/* </CircularContainer> */}

                <Typography variant="body2"  sx={{ textDecoration: 'none', color: 'black' ,fontSize:'0.7rem'}}>{props?.text.toUpperCase()}</Typography>

            </Box>

        </>
    )
}

export default Circle